import React from "react";
import { Link } from "gatsby";

const Faq = () => {
  return (
    <div className="bg-white dark:bg-zinc-950">
      <div className="mx-auto max-w-4xl sm:pt-24 sm:pb-24">
        <h2 className="text-4xl font-semibold tracking-tight text-zinc-900 sm:text-5xl dark:text-white">
          Frequently asked questions
        </h2>
        <dl className="mt-20 divide-y divide-zinc-900/10 dark:divide-white/10">
          <div className="py-8 first:pt-0 last:pb-0 lg:grid lg:grid-cols-12 lg:gap-8">
            <dt className="text-base/7 font-semibold text-zinc-900 lg:col-span-5 dark:text-white">
              What's the cheapest alternative to Statuspage?
            </dt>
            <dd className="mt-4 lg:col-span-7 lg:mt-0">
              <p className="text-base/7 text-zinc-600 dark:text-zinc-300">
                Cachet is a free status page tool (open-source, self-hosted),
                but it requires technical expertise and hosting costs. For
                hosted solutions, Statuspal starts at $49/month. However, the
                total cost depends on your needs. Cheaper entry pricing can
                become expensive as you scale with subscribers, multiple pages,
                and team members.
              </p>
            </dd>
          </div>
          <div className="py-8 first:pt-0 last:pb-0 lg:grid lg:grid-cols-12 lg:gap-8">
            <dt className="text-base/7 font-semibold text-zinc-900 lg:col-span-5 dark:text-white">
              Can I switch from Statuspage to another platform without losing my
              history?
            </dt>
            <dd className="mt-4 lg:col-span-7 lg:mt-0">
              <p className="text-base/7 text-zinc-600 dark:text-zinc-300">
                Yes. Sorry&#8482; has a{" "}
                <a
                  href="https://help.sorryapp.com/article/56-switching-from-atlassian-statuspage"
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold text-sky-500 dark:text-sky-400 underline underline-offset-2 hover:text-sky-600 dark:hover:text-sky-300"
                >
                  migration tool
                </a>
                , making it simple to migrate from Atlassian Statuspage to
                Sorry&#8482;. Other tools often let you migrate using their API
                or by creating historical incidents in the UI.
              </p>
            </dd>
          </div>
          <div className="py-8 first:pt-0 last:pb-0 lg:grid lg:grid-cols-12 lg:gap-8">
            <dt className="text-base/7 font-semibold text-zinc-900 lg:col-span-5 dark:text-white">
              Do I need a status page if I already use Slack or email for
              incident updates?
            </dt>
            <dd className="mt-4 lg:col-span-7 lg:mt-0">
              <p className="text-base/7 text-zinc-600 dark:text-zinc-300">
                Yes,{" "}
                <Link
                  to="/blog/why-you-need-a-status-page/"
                  className="font-semibold text-sky-500 dark:text-sky-400 underline underline-offset-2 hover:text-sky-600 dark:hover:text-sky-300"
                >
                  you need a status page
                </Link>
                . Slack and email work for internal teams up to a certain point,
                but status pages serve your customers and reduce support load. A
                good status page tool helps you communicate at scale.
              </p>
            </dd>
          </div>
          <div className="py-8 first:pt-0 last:pb-0 lg:grid lg:grid-cols-12 lg:gap-8">
            <dt className="text-base/7 font-semibold text-zinc-900 lg:col-span-5 dark:text-white">
              Is it worth paying for a status page when Cachet is free?
            </dt>
            <dd className="mt-4 lg:col-span-7 lg:mt-0">
              <p className="text-base/7 text-zinc-600 dark:text-zinc-300">
                It depends on your team's capabilities. Cachet is free but
                requires hosting, maintenance, security updates, and technical
                expertise. Hosted solutions cost money but include uptime
                guarantees, automatic updates, support, and no infrastructure
                management. Most teams find hosted solutions well worth the cost
                for the peace of mind they offer.
              </p>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default Faq;
